const loadFlickity = (callback = () => {}) => {
  if (window.Flickity) return callback()
  Shopify.loadStyles(Shopify.flickityStylesURL, "flickity-css")
  Shopify.loadScript(Shopify.flickityScriptURL, callback)
}

const bindZoom = () => {
  const element = $('.product-gallery-modal__flkty__item.is-selected');

  element.zoom({
    touch: false,
    magnify: 1.2,
    on: "click",
    onZoomIn: function() {
      element.addClass('zoom-out').removeClass('zoom-in');
    },
    onZoomOut: function() {
      element.addClass('zoom-in').removeClass('zoom-out');
    },
    onZoomStart: function() {
      element.removeClass('drag').addClass('zoom-in');
    },
    callback: function() {
      $(this).wrap("<div></div>").css('background', 'var(--color-floyd-background)').css("width", "100%");
    }
  });
}

const bindPinchZoom = () => {
  if(PinchZoom){
    setTimeout(() => {
      const element = $('.product-gallery-modal__flkty__item.is-selected img');
      if(!element.hasClass("has-pinchzoom")){
        const pinchZoom = new PinchZoom.default(element[0], {
          draggableUnzoomed: false,
        });
        pinchZoom.enable();
      }
    }, 10);
  }
}

createComponent("FlickityPVue", options => ({
  flkty: null,
  data: null,
  modalStore: getStore("modal"),
  options: options ?? {},
  get primaryImage() {
    return this.data?.[0] ?? this.options.initialImages?.[0] ?? { src: null, alt: '', width: 1, height: 1 }
  },
  goTo (cellIndex = 0, animate = true) {
    if (this.options.asNavFor) {
      Flickity.data(document.querySelector(this.options.asNavFor))?.select(cellIndex, false, !animate)
    } else {
      this.flkty.select(cellIndex, false, !animate)
    }
  },
  mountFlkty($el, data = null, initialSlide, callback = () => {}) {
    if (JSON.stringify(data) === JSON.stringify(this.data)) return;
    if (this.flkty) {
      this.flkty.select(0, false, true)
      this.flkty.destroy();
      this.flkty = null;
    }
    const mount = () => {
      this.data = data;
      setTimeout(() => {
        // Vue inserts list items at its anchors after Flickity restores the cells.
        // Restore photo order after that render, without moving an already-first cell.
        const primaryCell = $el.querySelector('[data-product-primary-cell]')
        if (primaryCell && $el.firstElementChild !== primaryCell) $el.prepend(primaryCell)
        this.flkty = new Flickity($el, {
          ...{},
          ...this.options,
          on: {
            change: (index) =>{ 
              window.innerWidth > 900 && bindZoom();
              window.innerWidth <= 900 && bindPinchZoom();
              if(this.modalStore.current)
                this.modalStore.data[this.modalStore.current].selectedImage = index;
            },
            ready: () => {
              window.innerWidth > 900 && bindZoom();
              window.innerWidth <= 900 && bindPinchZoom();
            },
            dragStart: () => {
              $('.product-gallery-modal__flkty__item.is-selected').trigger('zoom.destroy');
              $('.product-gallery-modal__flkty__item.is-selected').removeClass('zoom-in').removeClass('zoom-out').addClass('drag');
            },
            dragEnd: () => {
              $('.product-gallery-modal__flkty__item.is-selected').removeClass('drag').addClass('zoom-in');
            }
          }
        })
        if (!this.options.blockNavigationOnStaticClick) this.flkty.on( 'staticClick', ( _event, _pointer, _cellElement, cellIndex ) => this.goTo(cellIndex));
        if (initialSlide !== false) this.goTo(initialSlide ?? 0, false)
        callback(this.flkty)
      })
    }
    loadFlickity(() => setTimeout(mount, 0))
  }
}))
